import VxeListComponent from './src/list';
import { dynamicApp } from '../dynamics';
export var VxeList = Object.assign(VxeListComponent, {
    install: function (app) {
        app.component(VxeListComponent.name, VxeListComponent);
    }
});
export var List = VxeList;
dynamicApp.component(VxeListComponent.name, VxeListComponent);
export default VxeList;
